export default __webpack_public_path__ + "static/media/loop.68da5178.svg";